import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { useDebounce } from "../../components/Utils/SearchDebounce";
import Text from "./text";
import Button from "../button/button";
import { useNavigate } from "react-router-dom";
import CrossIcon from "../../icons/cross-icon";
import Tags from "../tags";

// Mirrors MIN_QUERY_LENGTH on the backend: shorter queries return nothing.
export const MIN_SEARCH_QUERY_LENGTH = 2;

// Item-level `Badge` values the backend may send, mapped onto the Tags pill.
const BADGE_STYLES = {
  Voided: { tagBackground: "greyBackground", textColor: "lightText" },
};
const DEFAULT_BADGE_STYLE = { tagBackground: "greyBackground", textColor: "lightText" };

const EditableText = ({
  placeholder = "Start typing...",
  suggestionData,
  universalSearchOpen,
  onSearch,
  isSearching = false,
  setUniversalSearchOpen,
}) => {
  const [value, setValue] = useState("");
  const [suggestionsOpen, setSuggestionsOpen] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const labelOverrides = {
    accounts: "Accounts",
    distributors: "Distributors",
    manufacturers: "Manufacturers",
    orders: "Orders",
    ivrs: "IVRs",
    invoices: "Invoices",
    tissueIds: "Tissue IDs",
  };

  useEffect(() => {
    if (universalSearchOpen) {
      requestAnimationFrame(() => {
        inputRef.current?.focus();
      });
    }
  }, [universalSearchOpen]);

  const debouncedValue = useDebounce(value, 300);

  useEffect(() => {
    if ((debouncedValue?.trim() ?? "").length < MIN_SEARCH_QUERY_LENGTH) {
      setSuggestionsOpen(false);
      return;
    }
    onSearch(debouncedValue);
    setSuggestionsOpen(true);
  }, [debouncedValue, onSearch]);

  const handleInput = (e) => {
    setValue(e.target.value);
  };

  return (
    <>
      {/* <div
        ref={ref}
        className="universal-search-text-input-container"
        contentEditable
        suppressContentEditableWarning
        data-placeholder={placeholder}
        onInput={handleInput}
        onFocus={() => value && setSuggestionsOpen(true)}
        // onBlur={() => {
        //   setTimeout(() => setSuggestionsOpen(false), 150);
        // }}
      ></div> */}

      <div className="universal-search-input-wrapper">
        <input
          ref={inputRef}
          value={value}
          onChange={handleInput}
          className="universal-search-text-input-container"
          placeholder={placeholder}
        />
        <div onClick={() => setUniversalSearchOpen(false)}>
          <CrossIcon className="modal-cross-icon" />
        </div>
      </div>
      {suggestionsOpen && (
        <div className="universal-search-suggestions-dropdown-container">
          {isSearching && (
            <div className="universal-search-suggestions-items-wrapper">
              <Text color="lightText">Searching...</Text>
            </div>
          )}
          {!isSearching &&
            (Object.entries(suggestionData || {})
              ?.filter(([, items]) => Array.isArray(items) && items.length > 0)
              .map(([groupKey, items]) => {
                const formattedLabel = groupKey
                  .replace(/_/g, " ")
                  .replace(/([a-z])([A-Z])/g, "$1 $2");
                const fallbackLabel = formattedLabel.length
                  ? `${formattedLabel[0].toUpperCase()}${formattedLabel.slice(1)}`
                  : groupKey;
                const label = labelOverrides[groupKey] || fallbackLabel;

                return (
                  <div
                    key={groupKey}
                    className="universal-search-individual-section-wrapper"
                  >
                    <div>
                      <Text color="lightText">{label}</Text>
                    </div>
                    {items?.map((item, index) => {
                      const navigateLink =
                        item?.Path ||
                        (item?.Link && item?.ID != null
                          ? `${item.Link}/${item.ID}`
                          : item?.Link);

                      return (
                        <div
                          key={index}
                          className="universal-search-suggestions-items-wrapper"
                          onClick={() => {
                            if (!navigateLink) return;
                            setUniversalSearchOpen(false);
                            navigate(navigateLink);
                          }}
                        >
                          <div className="universal-search-suggestion-row">
                            <Button variant="link">
                              {item?.Name ?? item?.label ?? item?.value ?? ""}
                            </Button>
                            {item?.Badge && (
                              <Tags
                                size="small"
                                tagText={item.Badge}
                                {...(BADGE_STYLES[item.Badge] || DEFAULT_BADGE_STYLE)}
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              }))}
          {!isSearching &&
            (!suggestionData ||
              Object.entries(suggestionData).every(
                ([, items]) => !Array.isArray(items) || items.length === 0
              )) && (
              <div className="universal-search-suggestions-items-wrapper">
                <Text color="lightText">No results found</Text>
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default EditableText;
